var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center",class:{ 'mb-2': this.$store.state.restaurant.description != null },style:(_vm.cssProps)},[(_vm.$store.getters.customizationLogo)?_c('img',{staticClass:"mr-2",staticStyle:{"max-height":"28px"},attrs:{"src":_vm.$store.getters.customizationLogo}}):_vm._e(),_c('h4',{staticClass:"tp-title-bold restaurant-title",class:{
      'restaurant-title--white': _vm.$store.getters.customizationMenuDarkMode
    }},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }